import type { IAPIRes } from '@/types/IAPIRes';
import { useAxios } from '@/boot/axios';
import type {
  IHomeSearch,
  IHomeSearchResults,
  ISearchAutoComplete,
} from '@/types/IHomeSearch';
import { ISiteCards } from '@/types/ISiteCards';

export interface IAuthService {
  search: (url: string) => Promise<IAPIRes<IHomeSearch>>;
  autoComplete: (query: string) => Promise<IAPIRes<ISearchAutoComplete[]>>;
}

export const randomSites = async (url?: string | null): Promise<IAPIRes<ISiteCards>> => {
  const { axiosInstance } = useAxios();
  url = url ? `?url=${url}` : '';
  const response =
    await axiosInstance.get<IAPIRes<ISiteCards>>(`/home/data${url}`);
  return response.data;
};

export const search = async (url: string): Promise<IAPIRes<IHomeSearch>> => {
  const { axiosInstance } = useAxios();
  const response = await axiosInstance.get<IAPIRes<IHomeSearch>>(
    `/search?url=${url}`,
  );
  return response.data;
};

export const getSearchResults = async (
  string: string,
  page: number,
): Promise<IAPIRes<IHomeSearchResults>> => {
  const { axiosInstance } = useAxios();
  const response = await axiosInstance.get<IAPIRes<IHomeSearchResults>>(
    `/search/all-results?string=${string}&page=${page}`,
  );
  return response.data;
};

export const autoComplete = async (
  query: string,
  options?: { signal?: AbortSignal },
): Promise<IAPIRes<ISearchAutoComplete[]>> => {
  const { axiosInstance } = useAxios();
  const response = await axiosInstance.get<IAPIRes<ISearchAutoComplete[]>>(
    `/autocomplete?query=${query}`,
    {
      signal: options?.signal,
    },
  );
  return response.data;
};
